<template>
  <div class="content">
    <el-form :inline="true" style="margin: 20px 0">
      <el-button class="addBtn" type="primary" size="small" @click="handleAdd"
        >新增</el-button
      >
      <!-- <el-form-item label="地址称呼: " style="margin: 0 20px" size="small">
        <el-input
          v-model="listQuery.name"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-button type="primary" @click="getListData" size="small"
        >搜索</el-button
      > -->
    </el-form>
    <!-- 分类表格 -->
    <el-table
      border
      :data="tableData"
      style="width: 100%; overflow-y: scroll !important"
      height="calc(100vh - 220px)"
      v-loading="loading"
      element-loading-spinner="el-icon-loading"
      element-loading-text="正在加载中"
    >
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="180"
      ></el-table-column>
      <el-table-column label="地址" align="center">
        <template slot-scope="scope"> {{ scope.row.address }} </template>
      </el-table-column>

      <el-table-column label="操作" width="180" align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            @click="handleEdit(scope.row)"
            primary
            >修改</el-button
          >
          <el-button
            size="mini"
            type="text"
            style="color: rgb(255, 0, 0)"
            @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 产品提交表单 -->
    <el-dialog
      :title="inpitTypeName"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="dialogForm" label-width="90px">
        <el-form-item label="地址" required>
          <el-input
            v-model="dialogForm.address"
            clearable
            type="textarea"
            :rows="3"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancelBtn" @click="dialogFormVisible = false"
          >取 消</el-button
        >
        <el-button class="addBtn" type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  selectAddress,
  updateAddress,
  deleteAddress,
  addAddress,
} from "@/services/nurseAddress/index";
import { IP } from "@/services/index.js";
export default {
  created() {
    this.getListData();
  },
  data() {
    return {
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        name: "",
      },
      goodsTitle: "",
      tableData: [],
      dialogFormVisible: false,
      dialogForm: {},
      inpitTypeName: "",
      formLabelWidth: "120px",
      action: IP + "/uploadFile/add",
      fileList: [],
      loading: false,
      pageCount: "",
      pageSize: 8,
      form: {
        productNurse: 1,
      },
      status: 0,
    };
  },
  methods: {
    async getListData() {
      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      this.loading = true;
      const { data, code, count } = await selectAddress(listQuery);
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },

    handleAdd(type) {
      this.dialogFormVisible = true;
      this.inpitTypeName = "新增地址";
      this.fileList = [];
      this.dialogForm = {};
      this.isaddAddressselectAddressOne = 1;
    },

    /* 修改 */
    handleEdit(row) {
      this.fileList = [];
      this.dialogFormVisible = true;
      this.inpitTypeName = "修改地址";
      this.dialogForm = JSON.parse(JSON.stringify(row));
    },

    handleSuccess_cover(e) {
      this.dialogForm.img = e.data;
    },

    /* 保存 */
    save() {
      //必填字段校验
      if (
        !this.dialogForm.address
      ) {
        this.$message.error("请填写必填字段");
        return;
      }

      if (this.inpitTypeName == "新增地址") {
        addAddress({ ...this.dialogForm }).then((res) => {
   
          if (res.code) {
            this.$message({
              type: "success",
              message: "新增成功!",
            });
            this.dialogFormVisible = false;
            this.getListData();
          }
        });
      }
      if (this.inpitTypeName == "修改地址") {
        updateAddress(this.dialogForm).then((resp) => {
  
          if (resp.code == 200) {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
            this.dialogFormVisible = false;
            this.getListData();
          }
        });
      }
    },

    /* 删除 */
    handleDelete(row) {
      console.log(row.id);
      this.$confirm(`此操作将永久删除'${row.address}'地址吗, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteAddress({ id: row.id }).then((res) => {
     
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getListData();
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.content {
  margin: 20px auto;
  width: 96%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.goodsTitle:hover {
  cursor: pointer;
}
.upload-demo {
  margin: 20px;
}
</style>
